import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '@shared/session.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router, private session: SessionService) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      if (token) {
        this.session.saveSession(token);
      }

      this.router.navigateByUrl('/coinflip');
      // eslint-disable-next-line no-self-assign
      window.location.href = `${window.location.origin}/coinflip`;
    });
  }
}
